import React from 'react';
import './ProductAnalysis.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const ProductAnalysis = () => {
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { t, lang } = useLanguage();

  const analysisData = [
    {
      title: "DRYCOW PREMIX",
      subtitle: lang === 'TR' 
        ? "Kuru Dönem Premiksi • TR:5800051 • 25 kg kraft çuval" 
        : lang === 'AR'
        ? "بريمكس فترة الجفاف • TR:5800051 • كيس كرافت 25 كجم"
        : "Dry Period Premix • TR:5800051 • 25 kg kraft bag",
      placeholder: lang === 'TR'
        ? "Drycow Premix kuru dönem premiksi kraft torba etiketi"
        : lang === 'AR'
        ? "ملصق كيس كرافت بريمكس دراي كاو لفترة الجفاف"
        : "Drycow Premix dry period premix kraft bag label",
      stats: [
        { label: lang === 'TR' ? "Ham Protein" : lang === 'AR' ? "بروتين خام" : "Crude Protein", value: "%12" },
        { label: lang === 'TR' ? "Ham Kül" : lang === 'AR' ? "رماد خام" : "Crude Ash", value: "%28" },
        { label: lang === 'TR' ? "Kalsiyum" : lang === 'AR' ? "كالسيوم" : "Calcium", value: "%12" },
        { label: lang === 'TR' ? "Fosfor" : lang === 'AR' ? "فوسفور" : "Phosphorus", value: "%4" }
      ]
    },
    {
      title: "FRESHCALVE PREMIX",
      subtitle: lang === 'TR'
        ? "Doğum Sonrası Premiksi • TR:5800051 • 25 kg kraft çuval"
        : lang === 'AR'
        ? "بريمكس ما بعد الولادة • TR:5800051 • كيس كرافت 25 كجم"
        : "Post-Partum Premix • TR:5800051 • 25 kg kraft bag",
      placeholder: lang === 'TR'
        ? "Freshcalve Premix doğum sonrası premiksi kraft torba etiketi"
        : lang === 'AR'
        ? "ملصق كيس كرافت بريمكس فريش كالف لما بعد الولادة"
        : "Freshcalve Premix post-partum premix kraft bag label",
      stats: [
        { label: lang === 'TR' ? "Ham Protein" : lang === 'AR' ? "بروتين خام" : "Crude Protein", value: "%14" },
        { label: lang === 'TR' ? "Kalsiyum" : lang === 'AR' ? "كالسيوم" : "Calcium", value: "%10" },
        { label: lang === 'TR' ? "Magnezyum" : lang === 'AR' ? "ماغنيسيوم" : "Magnesium", value: "%4" },
        { label: "Vitamin E", value: "3000 mg/kg" }
      ]
    },
    {
      title: "VITACALF ELECTROLYTE",
      subtitle: lang === 'TR'
        ? "Buzağı Elektroliti • TR:5800051 • 5 kg paket"
        : lang === 'AR'
        ? "إلكتروليت العجول • TR:5800051 • عبوة 5 كجم"
        : "Calf Electrolyte • TR:5800051 • 5 kg package",
      placeholder: lang === 'TR'
        ? "Vitacalf Electrolyte buzağı elektroliti etiketli paket"
        : lang === 'AR'
        ? "عبوة ملصقة لإلكتروليت العجول فيتاكالف"
        : "Vitacalf Electrolyte calf electrolyte labeled package",
      stats: [
        { label: lang === 'TR' ? "Sodyum" : lang === 'AR' ? "صوديوم" : "Sodium", value: "%8" },
        { label: lang === 'TR' ? "Potasyum" : lang === 'AR' ? "بوتاسيوم" : "Potassium", value: "%6" },
        { label: lang === 'TR' ? "Klorür" : lang === 'AR' ? "كلوريد" : "Chloride", value: "%12" },
        { label: lang === 'TR' ? "Glukoz/Dekstroz" : lang === 'AR' ? "جلوكوز / دكستروز" : "Glucose/Dextrose", value: "%35" }
      ]
    },
    {
      title: "ENERGY ELECTROLYTE LIQUID",
      subtitle: lang === 'TR'
        ? "Büyükbaş Enerjili Elektrolit Sıvı • TR:5800051 • 1 L / 5 L"
        : lang === 'AR'
        ? "سائل إلكتروليت الطاقة للماشية • TR:5800051 • 1 لتر / 5 لتر"
        : "Cattle Energy Electrolyte Liquid • TR:5800051 • 1 L / 5 L",
      placeholder: lang === 'TR'
        ? "Energy Electrolyte Liquid büyükbaş doğum sonrası enerjili elektrolit sıvı şişe etiketi"
        : lang === 'AR'
        ? "ملصق زجاجة سائل إلكتروليت الطاقة لما بعد الولادة للماشية"
        : "Energy Electrolyte Liquid cattle post-partum energy electrolyte liquid bottle label",
      stats: [
        { label: lang === 'AR' ? "بروبيلين غليكول" : "Propilen Glikol", value: "%25" },
        { label: lang === 'TR' ? "Kalsiyum" : lang === 'AR' ? "كالسيوم" : "Calcium", value: "%3" },
        { label: lang === 'TR' ? "Sodyum" : lang === 'AR' ? "صوديوم" : "Sodium", value: "%2.5" },
        { label: "pH", value: "6.0–7.5" }
      ]
    },
    {
      title: "ENERGY ELECTROLYTE POWDER",
      subtitle: lang === 'TR'
        ? "Büyükbaş Enerjili Elektrolit Toz • TR:5800051 • 5 kg / 10 kg"
        : lang === 'AR'
        ? "مسحوق إلكتروليت الطاقة للماشية • TR:5800051 • 5 كجم / 10 كجم"
        : "Cattle Energy Electrolyte Powder • TR:5800051 • 5 kg / 10 kg",
      placeholder: lang === 'TR'
        ? "Energy Electrolyte Powder büyükbaş doğum sonrası enerjili elektrolit toz kraft paket etiketi"
        : lang === 'AR'
        ? "ملصق عبوة كرافت لمسحوق إلكتروليت الطاقة لما بعد الولادة للماشية"
        : "Energy Electrolyte Powder cattle post-partum energy electrolyte powder kraft package label",
      stats: [
        { label: lang === 'TR' ? "Glukoz/Dekstroz" : lang === 'AR' ? "جلوكوز / دكستروز" : "Glucose/Dextrose", value: "%30" },
        { label: lang === 'TR' ? "Sodyum" : lang === 'AR' ? "صوديوم" : "Sodium", value: "%7" },
        { label: lang === 'TR' ? "Potasyum" : lang === 'AR' ? "بوتاسيوم" : "Potassium", value: "%5" },
        { label: lang === 'TR' ? "Klorür" : lang === 'AR' ? "كلوريد" : "Chloride", value: "%10" }
      ]
    },
    {
      title: "VITACALF Buzağı Maması",
      subtitle: lang === 'TR'
        ? "Süt İkame / Buzağı Maması • TR:5800051 • 25 kg kraft çuval"
        : lang === 'AR'
        ? "بديل الحليب / غذاء العجول • TR:5800051 • كيس كرافت 25 كجم"
        : "Milk Replacer / Calf Milk • TR:5800051 • 25 kg kraft bag",
      placeholder: lang === 'TR'
        ? "Bigma Premiks ve Buzağı destek ürünleri teknik web bölümü"
        : lang === 'AR'
        ? "القسم الفني لمنتجات بريمكس ودعم العجول من بيغما"
        : "Bigma Premix and Calf support products technical web section",
      stats: [
        { label: lang === 'TR' ? "Ham Protein" : lang === 'AR' ? "بروتين خام" : "Crude Protein", value: "%20–22" },
        { label: lang === 'TR' ? "Ham Yağ" : lang === 'AR' ? "دهن خام" : "Crude Fat", value: "%14–16" },
        { label: lang === 'TR' ? "Kullanım" : lang === 'AR' ? "الاستخدام" : "Usage", value: "125–150 g/L" },
        { label: lang === 'TR' ? "Su" : lang === 'AR' ? "ماء" : "Water", value: "40–45°C" }
      ]
    }
  ];

  return (
    <section className="analysis-section">
      <div className="analysis-container">
        <div className="analysis-header">
          <span className="analysis-badge">{t('analysis.badge')}</span>
          <h2>{t('analysis.title')}</h2>
          <p>{t('analysis.desc')}</p>
        </div>

        <div className="analysis-grid">
          {analysisData.map((item, index) => (
            <div key={index} className="analysis-card">
              <div className="card-top">
                <div className="analysis-placeholder-box">
                  <p>{item.placeholder}</p>
                </div>
                <div className="analysis-text">
                  <h3>{item.title}</h3>
                  <span className="analysis-subtitle">{item.subtitle}</span>
                </div>
              </div>
              
              <div className="stats-table">
                {item.stats.map((stat, i) => (
                  <div key={i} className="stat-row">
                    <span className="stat-label">{stat.label}</span>
                    <span className="stat-value">{stat.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductAnalysis;